import { CheckIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  InputRightElement,
  useColorModeValue,
} from "@chakra-ui/react";
import { Transaction, TransactionParam } from "@models/payment";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { usePaymentStore, validateDiscountCode } from "../../../payment";

const CheckoutDiscountInput = () => {
  const transaction = usePaymentStore((state) => state.transaction);
  const event = usePaymentStore((state) => state.event);
  const discount = usePaymentStore((state) => state.discount);
  const _t = (key?: string) => key || "";
  const borderColor = useColorModeValue("neutral.100", "neutral.600");

  const {
    register,
    formState: { errors },
    setError,
    clearErrors,
    setValue,
    getValues,
    handleSubmit,
  } = useForm<{
    discountCode: string;
  }>({});

  useEffect(() => {
    const _transaction = usePaymentStore.getState().transaction;
    if (!_transaction) return;
    if (discount) {
      console.log("DiscountInput: discount applied", discount);
      _transaction.applyDiscount(discount);
      setValue("discountCode", discount.code);
      console.log("DiscountInput: discount applied", _transaction);
    } else {
      console.log("DiscountInput: discount removed");
      setValue("discountCode", "");
      _transaction.removeDiscount();
    }
    usePaymentStore.setState({
      transaction: new Transaction(_transaction.json as TransactionParam),
    });
  }, [discount]);

  if (!event || !transaction) return <></>;

  const removeDiscount = () => {
    setValue("discountCode", "");
    usePaymentStore.setState({
      discount: null,
    });
  };

  const applyDiscount = async () => {
    clearErrors("discountCode");
    const discountCode = getValues().discountCode;
    if (!discountCode) return;
    const discount = await validateDiscountCode(event.id, discountCode);
    if (!discount)
      return setError("discountCode", {
        type: "manual",
        message: "Invalid code",
      });

    if (!discount.reusable && discount.remainUse == 0)
      return setError("discountCode", {
        type: "manual",
        message: "This code has been used",
      });

    usePaymentStore.setState({
      discount,
    });
  };

  return (
    <form onSubmit={handleSubmit((data) => {})}>
      <FormControl
        isInvalid={!!errors.discountCode}
        className="flex flex-col w-full mr-6 mb-10"
      >
        <div className="flex flex-row items-center h-full">
          <InputGroup className="flex-grow">
            <Input
              readOnly={!!transaction.discount}
              borderColor={transaction.discount ? "primary.300" : borderColor}
              h="100%"
              type={"text"}
              fontSize="1em"
              placeholder={_t(
                "Enter Discount / Redeem / Referral Code (if any)"
              )}
              sx={{
                textTransform: "uppercase",
                "&::placeholder": {
                  textTransform: "none",
                },
              }}
              {...register("discountCode")}
            />
            {transaction.discount && (
              <InputRightElement h="full" mr={3}>
                <CheckIcon color="primary.300" />
              </InputRightElement>
            )}
          </InputGroup>
          {!transaction.discount ? (
            <Button
              type="submit"
              variant="gradient"
              className="text-lg px-6 py-3 font-bold ml-4 w-24"
              onClick={applyDiscount}
              h="100%"
            >
              Apply
            </Button>
          ) : (
            <Button
              type="reset"
              variant="gradient"
              className="text-lg px-6 py-3 font-bold ml-4 w-24"
              onClick={removeDiscount}
              h="100%"
            >
              Remove
            </Button>
          )}
        </div>

        <FormErrorMessage>
          {errors.discountCode && errors.discountCode.message}
        </FormErrorMessage>
      </FormControl>
    </form>
  );
};

export default CheckoutDiscountInput;
